import React from 'react';
import { Form, Input, Button,Spin,Select } from 'antd';
import axios from 'axios'
import * as serverconfig from '../../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import PhoneInput from 'react-phone-number-input'

var CryptoJS = require("crypto-js");
const { Option } = Select;

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;


var token= ''
var sacco= ''


class HubForm extends React.Component {

  state = {
    name:'' ,  
    idtypeDescription:'',
    IDvaliditydays:0,
    datarequested:false,

    supervisor_name:'',
    District:'',
    districts:[],
    supervisor_phone:'',
    location_longitude:0,
    location_latitude:0,

    is_ntrl_hub:false,
    main_hub:false,

  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    //get the instance_id package here
    axios.get(serverconfig.backendserverurl+`/api/districts/`)
    .then(res => {
      this.setState({
        districts:res.data
      })
        this.setState({datarequested:false})
    })
  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('name', this.state.name);
    form_data.append('supervisor_name', this.state.supervisor_name);
    form_data.append('supervisor_phone', this.state.supervisor_phone);

    form_data.append('district', this.state.District);

    form_data.append('location_latitude', this.state.location_latitude);
    form_data.append('location_longitude', this.state.location_longitude);

    form_data.append('is_ntrl_hub', this.state.is_ntrl_hub);
    form_data.append('main_hub', this.state.main_hub);

    axios.post(serverconfig.backendserverurl+'/api/collectionhubs/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res =>    
    this.setState({datarequested:false})
,    window.location.reload(false)
  )
  .catch(error => console.log(error))

  }

  handlenameChange= (e) => this.setState({ name: e.target.value});
  handleIDDescriptionChange= (e) => this.setState({ idtypeDescription: e.target.value});

  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
      <FormItem label="Hub Name"
        name="idname"
        rules={[
          {
            required: true,
            message: 'Please input name',
          },
        ]}
      >
        <Input name="name"  placeholder="Put a name here." value={this.state.name} onChange={this.handlenameChange} />
      </FormItem>


      <FormItem label="Supervisor name"
        name="supervisor_name"
        rules={[
          {
            required: true,
            message: 'Please input supervisor_name',
          },
        ]}    
      >
        <Input name="supervisor_name"  placeholder="Name here" value={this.state.supervisor_name} onChange={(val)=>{this.setState({supervisor_name:val.target.value})}} />
      </FormItem>

      <FormItem label= { <h6 style={{display:'flex'}} >Supervisor phone contact</h6>}                       
      >
         <PhoneInput
            countrySelectProps={{ unicodeFlags: true }}
            defaultCountry="UG"
            placeholder="Enter phone number"
            value={this.state.supervisor_phone} onChange={(val)=>{this.setState({supervisor_phone:val})}}/>
       </FormItem> 

     
      <FormItem label="District"
          name="district"
          rules={[
            {
              required: true,
              message: 'Please enter district of residence',
            },
          ]}           
      >
        <Select
          placeholder="Ug District"
          style={{  }} 
          value={this.state.District}
            onChange={(val)=>{this.setState({District:val})}} 
            
            showSearch
            optionFilterProp="children"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onSearch={this.onSearch}
            
            >
          {this.state.districts.map(
            (dist)=>(
              <Option value={dist.district_name}>{dist.district_name} | {dist.region}</Option>
            ))}
        </Select>
      </FormItem>

   


      <FormItem label="Address latitude"    
      >
        <Input  type='number'  name="Address latitude"  placeholder="Latitude here" value={this.state.location_latitude} onChange={(val)=>{this.setState({location_latitude:val.target.value})}} />
      </FormItem>

      <FormItem label="Address longitude"    
      >
        <Input  type='number'  name="Address longitude"  placeholder="Longitude here" value={this.state.location_longitude} onChange={(val)=>{this.setState({location_longitude:val.target.value})}} />
      </FormItem>

      <FormItem>
        <Button  type="primary" htmlType="submit">{this.props.btnText}</Button>
      </FormItem>

      </Form>
        </div>
      );

    }
    
  }

}


export default HubForm;



